import { Injectable, inject } from '@angular/core';
import {SessionService} from "@core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {AttributionResult} from "./attribution-result.model";

@Injectable({
    providedIn: 'root'
})
export class AttributionService {
    private readonly sessionService = inject(SessionService);
    private readonly httpClient = inject(HttpClient);


    public retrieveAttribution(): Observable<AttributionResult> {
        const url = `${this.sessionService.getApiUrl()}/get_sbom_report`;
        return this.httpClient.get<AttributionResult>(url);
    }
}
